module.exports = __webpack_public_path__ + "frontend/images/pattern/black@2.jpg?d282a1b788c9d832811ad4aeb5763e8b";